var _clipPath, _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXGuy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 510 510",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1661,-5.15631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard4",
    transform: "matrix(1,0,0,1.04181,-0.614717,2633.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1661.62,
    y: -2522.69,
    width: 509.38,
    height: 488.958,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1661.62,
    y: -2522.69,
    width: 509.38,
    height: 488.958
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.677329,0,0,0.650148,1308.94,-1392.84)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1251.8,0,0,1238.63,572.152,-1064.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.076,-0.141C0.091,-0.158 0.105,-0.176 0.12,-0.194C0.135,-0.211 0.15,-0.229 0.165,-0.246L0.028,-0.411C0.033,-0.434 0.042,-0.453 0.057,-0.467C0.071,-0.481 0.088,-0.488 0.109,-0.488C0.119,-0.488 0.128,-0.487 0.135,-0.485C0.142,-0.482 0.149,-0.479 0.156,-0.474C0.162,-0.469 0.168,-0.464 0.174,-0.457C0.179,-0.45 0.185,-0.442 0.192,-0.433L0.264,-0.336L0.378,-0.487C0.381,-0.488 0.383,-0.488 0.386,-0.488L0.393,-0.488C0.421,-0.488 0.443,-0.482 0.46,-0.47C0.477,-0.458 0.485,-0.442 0.485,-0.423C0.485,-0.408 0.481,-0.394 0.474,-0.382C0.467,-0.37 0.453,-0.353 0.434,-0.332L0.356,-0.243L0.492,-0.064C0.489,-0.041 0.48,-0.023 0.465,-0.01C0.45,0.004 0.432,0.01 0.411,0.01C0.389,0.009 0.371,0.003 0.358,-0.01C0.344,-0.022 0.33,-0.037 0.317,-0.056L0.253,-0.148L0.143,0.007L0.123,0.008C0.093,0.008 0.07,0.002 0.054,-0.011C0.038,-0.024 0.03,-0.039 0.03,-0.058C0.03,-0.072 0.033,-0.085 0.04,-0.096C0.047,-0.107 0.059,-0.122 0.076,-0.141Z",
    style: {
      fill: "rgb(249,98,99)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.10536,0,0,1.10536,-19.5436,-2889.41)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.709386,0,0,0.709386,7.08472,738.28)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1330.98,
    cy: 863.719,
    r: 92.999,
    style: {
      fill: "white"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1330.98,751.108C1268.83,751.108 1218.37,801.567 1218.37,863.719C1218.37,925.871 1268.83,976.331 1330.98,976.331C1393.13,976.331 1443.59,925.871 1443.59,863.719C1443.59,801.567 1393.13,751.108 1330.98,751.108ZM1330.98,770.721C1382.3,770.721 1423.98,812.392 1423.98,863.719C1423.98,915.047 1382.3,956.718 1330.98,956.718C1279.65,956.718 1237.98,915.047 1237.98,863.719C1237.98,812.392 1279.65,770.721 1330.98,770.721Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.322543,0,0,0.322543,541.889,1056.84)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1330.98,
    cy: 863.719,
    r: 92.999
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.10536,0,0,1.10536,-262.507,-2889.41)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.709386,0,0,0.709386,7.08472,738.28)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1330.98,
    cy: 863.719,
    r: 92.999,
    style: {
      fill: "white"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1330.98,751.108C1268.83,751.108 1218.37,801.567 1218.37,863.719C1218.37,925.871 1268.83,976.331 1330.98,976.331C1393.13,976.331 1443.59,925.871 1443.59,863.719C1443.59,801.567 1393.13,751.108 1330.98,751.108ZM1330.98,770.721C1382.3,770.721 1423.98,812.392 1423.98,863.719C1423.98,915.047 1382.3,956.718 1330.98,956.718C1279.65,956.718 1237.98,915.047 1237.98,863.719C1237.98,812.392 1279.65,770.721 1330.98,770.721Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.322543,0,0,0.322543,541.889,1056.84)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1330.98,
    cy: 863.719,
    r: 92.999
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.959871,-1021.02,-248.11)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2683.25,
    y: -2369.51,
    width: 509.38,
    height: 488.958,
    style: {
      fill: "rgb(255,197,82)",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3198.46,-2375.35L2677.42,-2375.35L2677.42,-1874.72L3198.46,-1874.72L3198.46,-2375.35ZM3192.63,-2369.51L2683.25,-2369.51L2683.25,-1880.55L3192.63,-1880.55L3192.63,-2369.51Z",
    style: {
      fillOpacity: 0
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXGuy);
export default __webpack_public_path__ + "static/media/x_guy.8ebdc05885946e1e0b02e621d93cb640.svg";
export { ForwardRef as ReactComponent };